// Player names. Typed names are out until further notice (docs/plans/2026-10-19-character-select.md): a player is known by
// the character they pick, so what is left here is the clean-up the sim gives any name, and the check the avatar names pass.
import { lint } from '../../tools/banned-words.mjs';

export const MAX_NAME = 18;

/** Strip control characters and angle brackets, collapse whitespace, clamp to MAX_NAME characters. */
export function cleanName(raw: unknown): string {
  const s = typeof raw === 'string' ? raw.replace(/[\u0000-\u001f\u007f<>]/g, '').replace(/\s+/g, ' ').trim() : '';
  return Array.from(s).slice(0, MAX_NAME).join('') || 'Player';
}

/** True when the name carries a word the voice rules out (the same list the copy lint holds the pages to). */
export const bannedName = (name: string) => lint({ name }).length > 0;
